export default "__VITE_ASSET__CoDRZBOS__"